import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import UserDropdown, { UserDropdownInfiniteScrollProps } from 'src/components/UserDropdown/UserDropdown'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

interface CardUserFilterProps {
  recipientSet: Set<string>
  handleRecipientSelection: (userId: string) => Set<string>
  setRecipientSet: (users: Set<string>) => void
  recipientOptions: any[] | null
  userInfiniteScrollProps: UserDropdownInfiniteScrollProps
  defaultFilters: {
    recipient?: Set<string>
  }
}

const CardUserFilter: React.FC<CardUserFilterProps> = ({
  recipientSet,
  handleRecipientSelection,
  setRecipientSet,
  recipientOptions,
  userInfiniteScrollProps,
  defaultFilters,
}) => {
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <>
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Card User'} />
      </div>
      <UserDropdown
        css={css`
          margin-top: 8px;
        `}
        isCreatable={false}
        placeholder={translateSingleString(locale, 'All users')}
        chooseOption={(val: string): void => {
          handleRecipientSelection(val)
        }}
        isMulti={true}
        selectedValues={recipientSet}
        optionGroups={[
          {
            options: recipientOptions || [],
          },
        ]}
        onResetClick={(): void => {
          setRecipientSet(defaultFilters.recipient || new Set<string>())
        }}
        infiniteScrollProps={userInfiniteScrollProps}
      />
    </>
  )
}

export default CardUserFilter
